export enum PrimerStatusEnum {
    ALL = -1,
    PENDING = 0,
    AVAILABLE,
    OUT_OF_STOCK,
}
